import { render, staticRenderFns } from "./BenefitsEmail.vue?vue&type=template&id=ec77d29c&scoped=true&"
import script from "./BenefitsEmail.vue?vue&type=script&lang=js&"
export * from "./BenefitsEmail.vue?vue&type=script&lang=js&"
import style0 from "./BenefitsEmail.vue?vue&type=style&index=0&id=ec77d29c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec77d29c",
  null
  
)

export default component.exports